//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from "vuex";
import { debounce } from "quasar";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AddNewDynamicMember from "./AddNewDynamicMember/add-new-dynamic-member.vue";

export default {
    name: "AddEditGroupMembers",
    components: {
        AQButton,
        AddNewDynamicMember,
        FabricSearch
    },
    props: {
        actionType: { type: Object, default: () => {} },
        useProcessDefId: Boolean,
        editGroupDetails: { type: Object, default: () => {} },
        removeSearchBorder: {
            type: Boolean,
            default: false
        },
        excludeHeight: {
            type: Number,
            default: 200
        },
        heightAuto: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default: () => []
        },
        groupsToRemove: {
            type: Array,
            default: () => []
        },
        alreadySelectedMembers: {
            type: Array,
            default: () => []
        },
        enableAlreadySelected: {
            type: Boolean,
            default: false
        },
        isManager: {
            type: Boolean,
            default: false
        },
        noMargin: {
            type: Boolean,
            default: false
        },
        hiddenComponentTitle: {
            type: Boolean,
            default: false
        },
        fromAdmin: {
            type: Boolean,
            default: false
        },
        fromProcessInspector: {
            type: Boolean,
            default: false
        },
        fromPermissions: {
            type: Boolean,
            default: false
        },
        displayAllAssignee: {
            type: Boolean,
            default: false
        },
        hideSystemUsers: {
            type: Boolean,
            default: false
        },
        enablePagination: {
            type: Boolean,
            default: true
        },
        groupParents: {
            type: Array,
            default: () => []
        },
        groupMembersSearchValue: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            selectedMembers: [], // contain all selected members
            allMembersData: [],
            containerDataGroups: [],
            membersData: [],
            groupsDetails: {},
            searchValue: "",
            allSelectedText: "",
            parentId: "parent",
            containerInitialData: [],
            noMembersAvailable: false,
            loadDefaultElementsNr: 0,
            compCreated: false,
            showLoadMore: true,
            scrollDownFlag: false,
            paginationSettings: { // used on pagination
                pageNumber: 0,
                pageSize: 50
            },
            itemsToShowOnPagination: [],
            adminGroupUserIdDuplicated: "00000000-0000-0000-0000-000000000001" // hardcoded in backend
        };
    },
    computed: {
        ...mapGetters("admin", ["getSelectedMembers", "getSelectedMembersIds"]),
        getPropsMembers() {
            return {
                addCustom: true,
                alreadySelectedMembers: this.alreadySelectedMembers,
                parentId: this.parentId,
                selectedData: this.getSelectedMembersIds,
                loadDefaultElementsNr: this.loadDefaultElementsNr,
                enableAlreadySelected: this.enableAlreadySelected
            };
        },
        getListHeight() {
            return this.heightAuto ? "" : `height:calc(100vh - ${this.getSelectedMembers && this.getSelectedMembers.length
                ? (parseInt(this.excludeHeight, 10) + 22) : parseInt(this.excludeHeight, 10)}px)`;
        }
    },
    watch: {
        useProcessDefId: {
            handler() {
                // filter by application only when a single one is selected
                if (this.fromProcessInspector) {
                    if (!this.useProcessDefId) {
                        this.itemsToShowOnPagination = [];
                    }
                    this.getAllUsersGroupsData();
                }
            }
        },
        value: {
            handler(newValue) {
                if (newValue && !newValue.length) {
                    if (this.fromProcessInspector) {
                        this.searchValue = "";
                        this.searchMembers();
                    }
                }
            }
        },
        getSelectedMembers: {
            handler(newValue) {
                if (newValue.length < 1) {
                    this.$emit("noSelectedMember");
                }
                let groups = []; let
                    users = [];
                groups = newValue.filter(elem => elem.type === "GROUP" && (this.enableAlreadySelected || !this.alreadySelectedMembers.includes(elem.id)));
                users = newValue.filter(elem => elem.type === "USER" && (this.enableAlreadySelected || !this.alreadySelectedMembers.includes(elem.id)));
                const uc = users.length > 1 ? "showSelectedNrs" : "showSelectedNr";
                const gc = groups.length > 1 ? "showSelectedGroupNrs" : "showSelectedGroupNr";
                if (groups && users && groups.length && users.length) {
                    this.allSelectedText = `${users.length} ${this.$t(`admin.usersAndRoles.addGroupMembers.${uc}`)} ${
                        this.$t("admin.usersAndRoles.addGroupMembers.showAnd")} ${groups.length} ${this.$t(`admin.usersAndRoles.addGroupMembers.${gc}`)} ${
                        this.$t("admin.usersAndRoles.addGroupMembers.showSelected")}`;
                } else if (groups && groups.length) {
                    this.allSelectedText = `${groups.length} ${this.$t(`admin.usersAndRoles.addGroupMembers.${gc}`)} ${
                        this.$t("admin.usersAndRoles.addGroupMembers.showSelected")}`;
                } else if (users) {
                    this.allSelectedText = `${users.length} ${this.$t(`admin.usersAndRoles.addGroupMembers.${uc}`)} ${
                        this.$t("admin.usersAndRoles.addGroupMembers.showSelected")}`;
                }
                if (this.compCreated) {
                    this.$emit("input", newValue);
                }
            },
            immediate: true
        },
        groupMembersSearchValue: {
            handler(newValue) {
                this.searchValue = newValue;
                this.searchGroupMembers();
            }
        }
    },
    created() {
        this.searchGroupMembers = debounce(() => {
            if (this.enablePagination) {
                this.itemsToShowOnPagination = [];
                this.paginationSettings.pageNumber = 0;
            }
            this.getAllUsersGroupsData();
        }, 600);

        this.getAllUsersGroupsData();
        this.compCreated = true;
    },
    mounted() {
    },
    updated() {
        if (this.loadDefaultElementsNr === 0 && this.scrollDownFlag && this.showLoadMore && this.$refs.usersList) {
            const scrollToIndex = this.paginationSettings.pageSize * (this.paginationSettings.pageNumber ? this.paginationSettings.pageNumber : 1);
            this.$refs.usersList.$children[scrollToIndex].$el.scrollIntoView(false);
        }
    },
    beforeDestroy() {
        this.$store.commit("admin/removeSelectedMembers");
        this.$store.commit("admin/addNewMember");
    },
    methods: {
        getAllUsersGroupsData(loadMore) {
            this.loadDefaultElementsNr = 13;
            let payload = {
                searchValue: this.searchValue ? this.searchValue : "",
                groupId: this.editGroupDetails && this.editGroupDetails.id ? this.editGroupDetails.id : "",
                processDefinitionId: this.setProcessdefinitionId(),
                isManager: this.isManager,
                fromProcessInspector: this.fromProcessInspector,
                fromPermissions: this.fromPermissions,
                pagination: this.enablePagination
            };
            if (this.enablePagination) {
                payload = { ...payload, ...this.paginationSettings };
            }

            this.$store.dispatch("admin/getMembersLoadSearch", payload).then(
                data => {
                    if (data && data.length) {
                        data.forEach(element => {
                            if (element.id === this.adminGroupUserIdDuplicated && element.type === "GROUP") {
                                // eslint-disable-next-line no-param-reassign
                                element.adminId = `${this.adminGroupUserIdDuplicated}adminGroup`;
                            }
                            if (element.type === "GROUP") {
                                for (let i = 0; i < this.groupParents.length; i++) {
                                    if (this.groupParents[i] === element.id) {
                                        data.splice(data.indexOf(element), 1);
                                    }
                                }
                            }
                            return element;
                        });
                        if (this.enablePagination) {
                            if (payload.pageNumber) {
                                this.itemsToShowOnPagination = [...this.itemsToShowOnPagination, ...data];
                            } else {
                                this.itemsToShowOnPagination = [...data];
                            }
                            const checkShow = (this.itemsToShowOnPagination.length + this.groupParents.length) === this.paginationSettings.pageSize;
                            this.showLoadMore = this.itemsToShowOnPagination.length >= this.paginationSettings.pageSize
                                                    || (this.groupParents.length ? checkShow : false);
                        } else if (this.containerInitialData && !this.containerInitialData.length) {
                            this.containerInitialData = data;
                        }

                        this.$store.commit("admin/addNewMember", { id: "parent", data: this.enablePagination ? this.itemsToShowOnPagination : data });
                        this.noMembersAvailable = false;
                    } else if (this.enablePagination && loadMore && this.itemsToShowOnPagination && this.itemsToShowOnPagination.length) {
                        this.noMembersAvailable = false;
                        this.showLoadMore = false;
                    } else {
                        this.noMembersAvailable = !!this.searchValue;
                    }
                    setTimeout(() => {
                        this.loadDefaultElementsNr = 0;
                    }, 0);
                },
                () => {
                    this.showNotification(this.$t("admin.usersAndRoles.addGroupMembers.noMembersAvailable"));
                }
            );
        },
        loadMoreItems() {
            this.paginationSettings.pageNumber++;
            this.getAllUsersGroupsData(true);
            this.scrollDownFlag = true;
        },
        setProcessdefinitionId() {
            let processDef;
            if (this.useProcessDefId) {
                if (this.actionType && this.actionType.processDefinitionId) {
                    processDef = this.actionType.processDefinitionId;
                }
            } else if (this.fromAdmin || this.fromProcessInspector) {
                processDef = "CORE";
            }
            return processDef;
        },
        searchMembers() {
            const searchValueTrim = this.searchValue ? this.searchValue.trim() : "";
            if (searchValueTrim && searchValueTrim.length >= 3) {
                this.searchGroupMembers();
                this.$emit("searchValue", this.searchValue);
            } else {
                if (this.enablePagination) {
                    if (!searchValueTrim) {
                        this.searchValue = "";
                        this.itemsToShowOnPagination = [];
                        this.paginationSettings.pageNumber = 0;
                        this.getAllUsersGroupsData();
                    }
                } else {
                    this.$store.commit("admin/addNewMember", { id: "parent", data: this.containerInitialData });
                    // if the list is filtered by application from Process Inspector, show the filtered list when deleting search criteria
                    if (this.fromProcessInspector) {
                        this.getAllUsersGroupsData();
                    }
                }
                this.noMembersAvailable = false;
            }
        },

        showNotification(message) {
            this.$toast.showNotify({
                type: "error",
                message
            });
        }
    }
};

